import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { WorkItem, WorkItemControllerService } from '@rapider/sdk';
import { WorkitemsActions } from '../state/workitems.actions';
import { selectWorkitems, selectSelectedWorkitem } from '../state/workitems.reducer';

@Injectable({
  providedIn: 'root',
})
export class HomeDataService {
  private workItemService = inject(WorkItemControllerService);
  private store = inject(Store);

  /**
   * Retrieves work items with SWR: dispatches store action to load from API in background,
   * while immediately streaming currently cached items from the NgRx store.
   *
   * @param filters Optional kind or applicationId filters.
   * @returns Observable of work items from store.
   */
  getWorkItems(filters?: {
    kind?: string;
    applicationId?: string;
  }): Observable<WorkItem[]> {
    this.store.dispatch(WorkitemsActions.loadWorkitems({ filters }));
    return this.store.select(selectWorkitems);
  }

  /**
   * Optimistically updates work item status in the store and persists to backend.
   *
   * @param id Work item identifier.
   * @param status New status string.
   * @returns Observable from API call.
   */
  updateItemStatus(id: string, status: string): Observable<any> {
    this.store.dispatch(WorkitemsActions.updateWorkitemStatus({ id, status }));
    return this.workItemService.updateById({
      id,
      body: { status },
    });
  }

  /**
   * Loads full details of a specific work item by id.
   *
   * @param id Work item identifier.
   */
  loadWorkItemDetail(id: string): void {
    this.store.dispatch(WorkitemsActions.loadWorkitemDetail({ id }));
  }
}
